import { render } from "./BaseList.vue?vue&type=template&id=37e3e95f&scoped=true"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=37e3e95f&lang=scss&scoped=true"
import "./BaseList.vue?vue&type=style&index=1&id=37e3e95f&lang=scss"
script.render = render
script.__scopeId = "data-v-37e3e95f"

export default script